export default __webpack_public_path__ + "static/media/MailIcon.c79a9d00.svg";